import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isHeaderCheckboxChecked'
})
export class IsHeaderCheckboxCheckedPipe<T extends {[key: string]: any}> implements PipeTransform {

  transform(selected: T[], itemsOnPage: T[], property: string): unknown {
    // get items that selected and related to current page
    const selectedOnTargetPage = itemsOnPage.filter((itemsOnPage) => selected.map((s) => s[property]).includes(itemsOnPage[property]));

    if (selectedOnTargetPage.length === 0 || selectedOnTargetPage.length !== itemsOnPage.length) return false;

    return selectedOnTargetPage.every(checked =>
        itemsOnPage.find((source) => checked[property] === source[property])
    );
  }

}
